import { useCallback } from "react";
import { useDefaultBackToSearch } from "@/contexts/classified";
import { useBrandUrl } from "./useBrandUrl";
export const useBackToSearch = () => {
    const baseUrl = useBrandUrl();
    const classifiedSearch = "/classified-search?";
    const defaultBackToSearch = useDefaultBackToSearch();
    const trackingMedium = "&m=classified_detail_lead_confirmation_continue_last_search_classified_search_results";
    const url = `${baseUrl}${classifiedSearch}${defaultBackToSearch}${trackingMedium}`;
    const handleBackToSearch = useCallback(() => {
        if (defaultBackToSearch) {
            window.location.href = url;
        }
        else {
            window.location.href = baseUrl;
        }
    }, [baseUrl, defaultBackToSearch, url]);
    return {
        handleBackToSearch,
    };
};
